// Slow, seamless editorial marquee band.
export const Marquee = ({ items = [], className = "" }) => {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display text-4xl md:text-6xl text-white/90 px-6">{item}</span>
            <span className="text-weld text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
